import { render, staticRenderFns } from "./AutomaticPolicyRenewal.vue?vue&type=template&id=43da1652"
import script from "./AutomaticPolicyRenewal.vue?vue&type=script&lang=js"
export * from "./AutomaticPolicyRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports